// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"81d0a5f7","126":"338fa266","146":"216850e0","170":"2d95d044","298":"d53f6d4c","350":"94b0d0ef","685":"03730b5c"}[chunkId] + ".chunk.css";
};